import awIconService from 'js/awIconService';

/**
 * render function for des custom image cell
 * @param {*} param0 context for render function interpolation
 * @returns {JSX.Element} react component
 */
export const desCatalogCustomCellRenderFunction = (props) => {
    const {
        viewModel,
        ctxMin,
        actions,
        i18n,
        fields,
        grids,
        formProp,
        messages,
        ...prop
    } = props;
    let { item, vmo } = prop;
    if (!item) {
        item = vmo;
    }
    const title1 = vmo.cellHeader1;
    const title2 = vmo.cellHeader2;
    const thumbnailUrl = awIconService.getThumbnailFileUrl(item);

    return (
        <div className='des-catalog-custom-cell-card' title={vmo.cellHeader1}>
            <div className='des-catalog-custom-image-container'>
                <img src={thumbnailUrl} className='des-catalog-custom-image'></img>
            </div>
            <div className='des-catalog-custom-title-container'>
                <div className='des-catalog-custom-firstTitle '>
                    {title1}
                </div>
                <div className='des-catalog-custom-secondTitle'>
                    {title2}
                </div>
            </div>
        </div>
    );
};

